import { queryOptions, useQuery } from '@tanstack/vue-query';
import type {
  ApiLicenseIndexPage,
  ApiLicenseIndexEntranceBlock,
  ApiLicenseIndexCategoriesBlock,
  ApiLicenseIndexProductsBlock,
  ApiPaginatedResponse,
} from '@/types';
import { getBlock } from '@/utils/getBlock';

export function licenseIndexPageQueryOptions() {
  const { cmsFetch } = useCms();
  return queryOptions({
    queryKey: ['cms', 'pages', 'license-index'] as const,
    queryFn: () => cmsFetch<ApiPaginatedResponse<ApiLicenseIndexPage>>('/api/pages/', {
      type: 'pages.LicenseIndexPage',
      fields: '*',
    }),
  });
}

export function useLicenseIndexPage() {
  const query = useQuery(licenseIndexPageQueryOptions());

  const page = computed(() => query.data.value?.items?.[0] ?? null);
  const entrance = computed(() => page.value ? getBlock<ApiLicenseIndexEntranceBlock>(page.value.body, 'entrance') : undefined);
  const categories = computed(() => page.value ? getBlock<ApiLicenseIndexCategoriesBlock>(page.value.body, 'categories') : undefined);
  const products = computed(() => page.value ? getBlock<ApiLicenseIndexProductsBlock>(page.value.body, 'products') : undefined);

  return { ...query, page, entrance, categories, products };
}
